import { isObject } from '@cutwise/utils';

import { FancyColorGrade } from '@/customGrading/constants/FancyColorGrade';
import { FancyColorGradesType } from '@/customGrading/types/ColorGradesType';

class FancyColorGradeRepository {
  private fancyColorGrades?: FancyColorGradesType;

  initFancyColorGrades(fancyColorGrades: FancyColorGradesType) {
    this.fancyColorGrades = fancyColorGrades;
  }

  get options() {
    return (isObject(this.fancyColorGrades) ? Object.keys(this.fancyColorGrades) : []) as FancyColorGrade[];
  }
}

export const fancyColorGradeRepository = new FancyColorGradeRepository();
